import { useState } from "react";
import { useTranslation } from "react-i18next";

import ArticleItem from "./components/ArticleItem";

import {
  ArticleList,
  Icon,
  IconWrapper,
  NavWrapper,
  Title,
  Wrapper,
} from "./ArticleNavigation.styled";

const ArticleNavigation = ({ showIcon = true, anchors }) => {
  const [showMore, setShowMore] = useState(true);

  const { t } = useTranslation();

  const handleShowMore = () => {
    setShowMore(prevState => !prevState);
  };

  const handleNavigate = id => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Wrapper>
      <NavWrapper showMore={+showMore}>
        <Title>{t("article.navigation")}</Title>

        {showIcon && (
          <IconWrapper onClick={handleShowMore}>
            <Icon
              src="/assets/svg/naw-arrow.svg"
              alt="arrow"
              open={+showMore}
            />
          </IconWrapper>
        )}
      </NavWrapper>

      <ArticleList showMore={+showMore}>
        {anchors?.map(({ name, reference }) => (
          <ArticleItem
            key={name}
            href={name}
            onClick={() => handleNavigate(reference)}
          />
        ))}
      </ArticleList>
    </Wrapper>
  );
};

export default ArticleNavigation;
